import { FactoryWorkerPool } from '@qunhe/egs-lib';

let WorkerFactor: () => Worker;
let TranscoderWorkerBlobUrl: string | undefined;
WorkerFactor = () => {
    const workerUrl = new URL("./transcoder-worker.js", import.meta.url).href;

    if (!TranscoderWorkerBlobUrl) {
        const source = `import ${JSON.stringify(workerUrl)};`;
        TranscoderWorkerBlobUrl = URL.createObjectURL(new Blob([source], { type: "text/javascript" }));
    }

    return new Worker(TranscoderWorkerBlobUrl, { type: "module" });
};
const pool = new FactoryWorkerPool('transcode', WorkerFactor);

export default pool;
